import {AfterViewInit, Component, OnInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {StepService} from "../../services/step.service";

/**
 * Special component for the start page of the chapter "verbrauchsanalyse". Only Textoutputs, no form.
 */
@Component({
    selector: 'app-moderat-verbrauchsanalyse-start',
    templateUrl: './verbrauchsanalyse.start.component.html',
    standalone: false
})
export class VerbrauchsanalyseStartComponent extends StepComponent implements OnInit, AfterViewInit {

  /**
   * The default path to the previous page.
   */
  previousLink: string = "../../einstieg";

  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService) {
    super(stepService, router, elementService);
    if(this.router.getCurrentNavigation()?.extras?.state?.external === true) {
      this.previousLink = "../../extern";
    }
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element);
  }
}
